module.exports = {
	"name": "truffle-contract-schema",
	"version": "0.0.5",
	"description": "JSON schema for contract artifacts",
	"main": "index.js",
	"scripts": {
		"test": "mocha"
	},
	"repository": {
		"type": "git",
		"url": "git+https://github.com/trufflesuite/truffle-schema.git"
	},
	"keywords": [
		"ethereum",
		"json",
		"schema",
		"contract",
		"artifacts"
	],
	"author": "Tim Coulter <tim.coulter@consensys.net>",
	"license": "MIT",
	"bugs": {
		"url": "https://github.com/trufflesuite/truffle-schema/issues"
	},
	"homepage": "https://github.com/trufflesuite/truffle-schema#readme",
	"dependencies": {
		"crypto-js": "^3.1.9-1"
	},
	"devDependencies": {
		"mocha": "^3.2.0"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/truffle-contract-schema/package.json
// module id = 376
// module chunks = 2